import { AgendaBlock } from '@/lib/api/agenda-blocks/agenda-blocks-api'
import { getBlockTypeColor, BLOCK_TYPE_LABELS } from '../../utils/status-colors'
import { formatTime, formatDate } from '../../utils/calendar-utils'
import { MdEdit, MdDelete, MdRepeat, MdBlock } from 'react-icons/md'

interface BlockCardProps {
    block: AgendaBlock
    onEdit?: (block: AgendaBlock) => void
    onDelete?: (block: AgendaBlock) => void
    compact?: boolean
}

export function BlockCard({
    block,
    onEdit,
    onDelete,
    compact = false,
}: BlockCardProps) {
    const colors = getBlockTypeColor(block.type)
    const startDate = new Date(block.startDate)
    const endDate = new Date(block.endDate)

    const handleEdit = (e: React.MouseEvent) => {
        e.stopPropagation()
        if (onEdit) {
            onEdit(block)
        }
    }

    const handleDelete = (e: React.MouseEvent) => {
        e.stopPropagation()
        if (onDelete) {
            onDelete(block)
        }
    }

    if (compact) {
        return (
            <div
                className={`px-2 py-1 rounded text-xs truncate ${colors.bg} ${colors.border} border-l-4 ${colors.text}`}
                title={`${block.title} - ${formatTime(startDate)}`}
            >
                <MdBlock className="inline mr-1" />
                {formatTime(startDate)} {block.title}
            </div>
        )
    }

    return (
        <div
            className={`p-3 rounded-lg ${colors.bg} ${colors.border} border-l-4`}
        >
            <div className="flex items-start justify-between gap-2">
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                        <MdBlock className={`text-lg ${colors.text}`} />
                        <span
                            className={`font-medium text-sm ${colors.text}`}
                        >
                            {block.title}
                        </span>
                    </div>
                    <p className="text-xs text-base-content/60 mt-1">
                        {BLOCK_TYPE_LABELS[block.type] || block.type}
                    </p>
                </div>
                {block.recurring && (
                    <div className="tooltip" data-tip="Recorrente">
                        <MdRepeat className="text-base-content/50" />
                    </div>
                )}
            </div>

            {block.description && (
                <p className="text-xs text-base-content/70 mt-2 line-clamp-2">
                    {block.description}
                </p>
            )}

            <div className="flex items-center justify-between mt-3 pt-2 border-t border-base-300/30">
                <div className="text-xs text-base-content/60">
                    <div>
                        {formatDate(startDate, 'dd/MM')} {formatTime(startDate)}
                    </div>
                    <div>
                        {formatDate(endDate, 'dd/MM')} {formatTime(endDate)}
                    </div>
                </div>

                {(onEdit || onDelete) && (
                    <div className="flex items-center gap-1">
                        {onEdit && (
                            <button
                                className="btn btn-xs btn-ghost"
                                onClick={handleEdit}
                                title="Editar"
                            >
                                <MdEdit className="text-sm" />
                            </button>
                        )}
                        {onDelete && (
                            <button
                                className="btn btn-xs btn-ghost text-error"
                                onClick={handleDelete}
                                title="Excluir"
                            >
                                <MdDelete className="text-sm" />
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}
